
    var riot = require('riot')
    //src: starling/src/tags/header-save-indicator.html
riot.tag2('header-save-indicator',
  '<div if="{this.saving}" class="saving" ref="saving"> <img src="/images/icon-spinner-lt-40.gif" class="save-spinner"> <span class="save-label">saving...</span> </div> <div if="{this.saved}" class="saved" ref="saved"> <svg class="icon"> <title>all changes saved</title> <use xlink:href="#check-icon"></use> </svg> <span if="{this.showLabel}" class="save-label">all changes saved</span> </div> <div if="{this.failed}" class="failed" ref="failed"> <svg class="icon"> <use xlink:href="#warning-icon"></use> </svg> <span class="save-label">save failed</span> </div>',
  'header-save-indicator div,[data-is="header-save-indicator"] div{ font-size: 12px; margin-left: 8px; font-weight: 300; } header-save-indicator .saving,[data-is="header-save-indicator"] .saving{ color: var(--gray4); } header-save-indicator .saved,[data-is="header-save-indicator"] .saved{ color: var(--gray4); } header-save-indicator .failed,[data-is="header-save-indicator"] .failed{ color: var(--gray3); } header-save-indicator .icon,[data-is="header-save-indicator"] .icon{ height: 14px; width: 14px; color: var(--gray4); vertical-align: middle; } header-save-indicator .save-label,[data-is="header-save-indicator"] .save-label{ vertical-align: middle; } header-save-indicator .save-spinner,[data-is="header-save-indicator"] .save-spinner{ height: 18px; width: 18px; vertical-align: middle; margin-right: 2px; border-radius: 20px; }',
  '', function(opts) {
"use strict";

var _this = this;

this.canvas = this.opts.canvas;
this.canvas.headerSaveIndicator = this;

this.reset = function () {
  _this.saving = false;
  _this.saved = false;
  _this.failed = false;
  _this.showLabel = true;
  if (_this.savedTimeout) {
    clearTimeout(_this.savedTimeout);
    _this.savedTimeout = null;
  }
};

this.setSaving = function () {
  _this.reset();
  _this.saving = true;
  _this.update();
  _this.savedTimeout = setTimeout(function () {
    _this.setSaveFailed();
  }, 60000);
};

this.setSaved = function () {
  _this.reset();
  _this.saved = true;
  _this.update();
  _this.savedTimeout = setTimeout(function () {
    _this.showLabel = false;
    _this.update();
  }, 8000);
};

this.setSaveFailed = function () {
  _this.reset();
  _this.failed = true;
  _this.update();
};
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('header-save-indicator')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/header-save-indicator.html
// module id = 793
// module chunks = 0